import { render, staticRenderFns } from "./card-actions.vue?vue&type=template&id=04d8a517&scoped=true"
import script from "./card-actions.vue?vue&type=script&lang=js"
export * from "./card-actions.vue?vue&type=script&lang=js"
import style0 from "./card-actions.vue?vue&type=style&index=0&id=04d8a517&prod&lang=css"
import style1 from "./card-actions.vue?vue&type=style&index=1&id=04d8a517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8a517",
  null
  
)

export default component.exports